export default "__VITE_ASSET__BDb3C1F___"